import { gpfsMiddleware } from './gpfs-middleware';

export const gpfListMiddleware = [gpfsMiddleware];
